import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

import List from './List'
import HistoryCoin from './HistoryCoin'

const Index = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <List />
      </Route>
      <Route exact path={`${path}/:id/history`}>
        <HistoryCoin />
      </Route>
    </Switch>
  )
}

export default Index
